import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((toast) => {
    const id = Math.random().toString(36).substr(2, 9);
    setToasts((prev) => [...prev, { ...toast, id }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, toast.duration || 3000);
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div className="fixed z-50 bottom-6 right-6 flex flex-col gap-2 items-end">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`px-4 py-3 rounded-xl shadow-lg min-w-[220px] text-sm font-medium flex items-center gap-2 animate-fade-in-up
              ${toast.type === 'success' ? 'bg-green-100 text-green-800' : ''}
              ${toast.type === 'error' ? 'bg-red-100 text-red-800' : ''}
              ${toast.type === 'info' ? 'bg-blue-100 text-blue-800' : ''}
            `}
          >
            {toast.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}

// Add a simple fade-in-up animation
// In your global CSS (e.g. index.css):
// @keyframes fade-in-up { from { opacity: 0; transform: translateY(20px);} to { opacity: 1; transform: none; } }
// .animate-fade-in-up { animation: fade-in-up 0.3s ease; } 